import "./Projects.scss";
import Navbar from "../../components/Navbar/MainNavbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { Link } from "react-router-dom";
import { Grid } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { categoriesData } from "../../constants/categoryData";
import { textTransform } from "../../_helpers/textTransform";
import useTranslate from "../../hooks/useTranslate";

const Projects = () => {
  const { translate, language } = useTranslate();
  const isFa = language === "fa";

  return (
    <>
      <Navbar />
      <div
        className={`app_projects  ${isFa ? "rtl-mode" : "ltr-mode"}`}
        id="projects"
      >
        <div className="app_projects-grid">
          <Grid container spacing={0.2}>
            {categoriesData.map((cat) => (
              <Grid item xs={12} sm={6} md={6} key={cat.id}>
                <Link to={cat.link} className="category-card">
                  <div className={`category-card__wrapper ${!cat.src ? "category-card__wrapper--empty" : ""}`}>
                    {cat.src && <LazyLoadImage
                      effect="blur"
                      src={cat.src}
                      alt={cat.name}
                      className="category-card__image"
                    />}
                    <div className="category-card__overlay">
                      <h2 className="category-card__name">
                        {(translate(cat.titleKey) === cat.titleKey ? (isFa ? cat.titleFa : cat.title) : translate(cat.titleKey)) ||
                          textTransform(cat.name, "capitalize")}
                      </h2>
                    </div>
                  </div>
                </Link>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Projects;
